import { Navigate } from "react-router-dom";
import { getSessionData } from "../../utils/helper";
import { envMapping } from '../../utils/constants'

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const isLocalDevelopment = process.env.REACT_APP_LOCAL_DEVELOPMENT === 'true';
  
  if (isLocalDevelopment) {
    return children;
  }

  const userInfo = getSessionData();
  const userEnvGroups: string[] = userInfo?.envGroups || [];

  const hostname = window.location.hostname;
  const requiredEnv = envMapping[hostname];

  if (!requiredEnv || !userEnvGroups.includes(requiredEnv)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
